(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('MainUserDeactivatingController', [
            '$uibModalInstance',
            'agendaStatus',
            'result',
            MainUserDeactivatingControllerFn]);

    function MainUserDeactivatingControllerFn(
        $uibModalInstance,
        agendaStatus,
        result) {
        let viewModel = this;

        viewModel.agendaStatus = agendaStatus;
        viewModel.selectedAgenda = 0;
        
        // cancel
        viewModel.no = () => {
            $uibModalInstance.dismiss();
        };

        // ok
        viewModel.yes = () => {
            result.selectedAgenda = viewModel.selectedAgenda;
            $uibModalInstance.close();
        };
    }
})();
